export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_DATE = 'SET_DATE'
export const SET_VIEW = 'SET_VIEW'
export const SET_DASHBOARD = 'SET_DASHBOARD'
export const SET_DASHBOARDTOP = 'SET_DASHBOARDTOP'
export const SET_ADASRECORDS = 'SET_ADASRECORDS'
export const SET_COUNTS = 'SET_COUNTS'
export const SET_TOPSTATS = 'SET_TOPSTATS'
export const SET_PARAMETER = 'SET_PARAMETER'
export const SET_LOG = 'SET_LOG'
export const SET_INTERNAL_LOG = 'SET_INTERNAL_LOG'
export const RESET_LOG = 'RESET_LOG'
export const SET_EMAIL_LOG = 'SET_EMAIL_LOG'
export const FILTER_LOG = 'FILTER_LOG'
export const SET_EVALUATION = 'SET_EVALUATION'
export const SET_FAILEDVINS = 'SET_FAILEDVINS'
export const SET_BMS = 'SET_BMS'
export const SET_ALL_FIRMS = 'SET_ALL_FIRMS'
export const SET_FIRMS = 'SET_FIRMS'
export const RESET_DASHBOARD = 'RESET_DASHBOARD'
export const RESET_EVALUATION = 'RESET_EVALUATION'

export const SET_CLIENTREVIEW = 'SET_CLIENTREVIEW'
export const SET_CLIENTINSPECTIONS = 'SET_CLIENTINSPECTIONS'
export const SET_DECODESTATS = 'SET_DECODESTATS'
export const SET_CLIENTBREAKDOWN = 'SET_CLIENTBREAKDOWN'
export const SET_AI_PROMPT = 'SET_AI_PROMPT'
export const SET_AI_LOADING = 'SET_AI_LOADING'
export const RESET_QUOTE = 'RESET_QUOTE'
export const SET_QUOTE = 'SET_QUOTE'
export const RESET_PREDICTIVE = 'RESET_PREDICTIVE'
export const SET_PREDICTIVE = 'SET_PREDICTIVE'
export const SET_BMS_HISTORY = 'SET_BMS_HISTORY'
export const RESET_BMS_HISTORY = 'RESET_BMS_HISTORY'

export const DASHBOARD_SEARCH_TERM = 'DASHBOARD_SEARCH_TERM'
export const DASHBOARD_PAGE_SIZE = 'DASHBOARD_PAGE_SIZE'
export const DASHBOARD_SORT_DIR = 'DASHBOARD_SORT_DIR'
export const DASHBOARD_ORDER_BY = 'DASHBOARD_ORDER_BY'
export const DASHBOARD_FILTER_BY = 'DASHBOARD_FILTER_BY'
export const DASHBOARD_FIRMS = 'DASHBOARD_FIRMS'
export const DASHBOARD_ALLFIRMS = 'DASHBOARD_ALLFIRMS'

export const SET_FRAGMENTATION = 'SET_FRAGMENTATION'
export const SET_MISSING_INDEXES = 'SET_MISSING_INDEXES'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js